import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FaCheck, FaTimes } from "react-icons/fa";
import { jwtDecode }from "jwt-decode";
import { randomString, digits, symbols, lower, upper } from 'secure-random-password';
import '../../styles/UserList.css'
import { FaRegCopy ,FaRegEyeSlash, FaRegEye } from "react-icons/fa6";
import {
  Modal,
  Button,
  Icon,
  List,
  Dropdown,
  Header,
  Image,
  Grid,
  Input,
  Popup,
} from "semantic-ui-react";

import {
  getUsersList,
  addUserDataAPI,
  AddUserRequestSuccess,
} from "../../actions/dataConsoleAction";

import Loader from "../../components/Loader";
import ListView from "./ListView";
import CardPaginationTable from "../Pagination/CardPaginationTable";
import { all } from "axios";

const UserList = ({
  openUserAdd,
  handleCloseUserAdd,
  onSendUsersCount,
  showToaster,
  userSearchData,
}) => {
  // const [OpenAddUser, setOpenAddUser] = useState(false);
  const [inputUsername, setInputUsername] = useState("");
  const [finalUsername, setFinalUsername] = useState('');
  const [inputEmail, setInputEmail] = useState("");
  const [inputPassword, setInputPassword] = useState("");
  const [inputConfirmPassword, setInputConfirmPassword] = useState("");
  const [generatedPassword, setGeneratedPassword] = useState("");
  const [emailCommunication, setEmailCommunication] = useState(''); 
  const [access, setAccess] = useState("");
  const [loading, setLoading] = useState(true);
  const [allUserData, setAllUserData] = useState([]);
  const [usernameError, setUsernameError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [confirmPasswordError, setConfirmPasswordError] = useState(false);
  const isMounted = useRef(true);
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(9); // Default rows per page
  const [addUserFlag, setAddUserFlag] = useState(false);
  const [deleteB2cUserFlag, setDeleteB2cUserFlag] = useState(false);
  const orgDetails = useSelector((state) => state.admin.details);
  const [copied, setCopied] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false); 
  const [isSubmitting, setIsSubmitting] = useState(false); 
  const { allUsersData, allUsersDataStatus } = useSelector(
    (state) => state.allUsersList || {}
  );

  const { addUserData, addUserStatus } = useSelector(
    (state) => state.addUserDataB2c || {}
  );
  const generateStrongPassword = () => {
    const passwordLength = 16;  
    // Generate the password
    const password = randomString({
      length: passwordLength,
      characters: [lower, upper, digits, symbols]  // Mix of character sets
    });
  
    return password;
  };
  useEffect(() => {
    if (isMounted.current) {
      isMounted.current = false;
      dispatch(getUsersList());
      setLoading(true);
    }
    const password = generateStrongPassword();
    setGeneratedPassword(password);
  }, [isMounted, dispatch, openUserAdd]);
  
  useEffect(() => {
    if (openUserAdd) {
      setInputUsername("");
      setInputEmail("");  
      setEmailCommunication("");
      setIsSubmitting(false);  
    }
  }, [openUserAdd]);

  useEffect(() => {
    if (deleteB2cUserFlag) {
      dispatch(getUsersList());
      setDeleteB2cUserFlag(false);
    }
  }, [deleteB2cUserFlag]);

  useEffect(() => {
    if (allUsersDataStatus === 200) {
      setAllUserData(allUsersData);
      onSendUsersCount(allUsersData.length);
      setLoading(false);
    }
  }, [allUsersData, allUsersDataStatus]);

  useEffect(() => {
    if (allUsersData.length > 0) {
      if (userSearchData !== "") {
        const fitleredData = allUsersData.filter((results) => {
          return results.userName
            .toString()
            .toLowerCase()
            .includes(userSearchData);
        });
        if (fitleredData.length > 0) {
          setAllUserData(fitleredData);
        } else {
          setAllUserData([]);
        }
      } else {
        setAllUserData(allUsersData);
      }
    }
  }, [userSearchData, allUsersData]);

  useEffect(() => {
    if (addUserStatus === 200 && addUserFlag) {
      dispatch(getUsersList());
      handleCloseUserAdd();
      dispatch(AddUserRequestSuccess([]));
      showToaster(`"${finalUsername}" added successfully`, "success");
    } else if (addUserStatus === 400 && addUserFlag) {
      handleCloseUserAdd();
      dispatch(AddUserRequestSuccess([]));
      showToaster(`Failed to add "${finalUsername}"`, "error");
    }
  }, [addUserData, addUserStatus, inputUsername, addUserFlag]);

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const setDeleteUserFlag = () => {
    setDeleteB2cUserFlag(true);
  };

  const togglePasswordVisibility = () => { 
    setPasswordVisible(!passwordVisible);
  };

  const handleChange = (e, { name, value }) => {
    switch (name) {
      case "username":
        setInputUsername(value);
        const cleanedUsername = value
        .toLowerCase()
        .replace(/[^a-zA-Z0-9]/g, ""); 
        //setInputUsername(cleanedUsername);
        setUsernameError(false);
        if (cleanedUsername === "") {
          setInputEmail(`*****@${process.env.REACT_APP_EMAIL_DOMAIN}`);
        } else {
          const generatedEmail = `${cleanedUsername}@${process.env.REACT_APP_EMAIL_DOMAIN}`;
          setInputEmail(generatedEmail);
        }
        setEmailError(false);
        break;
      case "password":
        setInputPassword(value);
        validatePassword(value);
        break;
      case "access":
        setAccess(value);
        break;
      default:
        break;
    }
  };

  const validatePassword = (password) => {
    const regex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/;
    setPasswordError(!regex.test(password));
  };

  const renderPasswordRequirements = () => {
    return (
      <List>
        <List.Item>
          <List.Content floated="left">
            {inputPassword.length >= 8 ? (
              <FaCheck color="green" />
            ) : (
              <FaTimes color="red" />
            )}
          </List.Content>
          <List.Content>Password must be at least 8 characters</List.Content>
        </List.Item>
        <List.Item>
          <List.Content floated="left">
            {/(?=.*[a-z])/.test(inputPassword) ? (
              <FaCheck color="green" />
            ) : (
              <FaTimes color="red" />
            )}
          </List.Content>
          <List.Content>Contain at least one lowercase letter</List.Content>
        </List.Item>
        <List.Item>
          <List.Content floated="left">
            {/(?=.*[A-Z])/.test(inputPassword) ? (
              <FaCheck color="green" />
            ) : (
              <FaTimes color="red" />
            )}
          </List.Content>
          <List.Content>Contain at least one uppercase letter</List.Content>
        </List.Item>
        <List.Item>
          <List.Content floated="left">
            {/(?=.*\d)|(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+)$/g.test(
              inputPassword
            ) ? (
              <FaCheck color="green" />
            ) : (
              <FaTimes color="red" />
            )}
          </List.Content>
          <List.Content>Contain a number or symbol</List.Content>
        </List.Item>
      </List>
    );
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(inputPassword)
    .then(() => {
      setCopied(true); // Show the message
      setTimeout(() => setCopied(false), 2000); // Hide after 3 seconds
    })
    .catch(()=>{
      setCopied(false);
    })
    //showToaster(`Password Copied`, "success");
  };

  const handleSubmit = () => {
    const cleanedUsername = inputUsername.toLowerCase().replace(/[^a-zA-Z0-9]/g, "");
    setFinalUsername(cleanedUsername);
    if (!inputUsername) setUsernameError(true);
    if (!inputEmail) setEmailError(true);
    if (inputPassword !== inputConfirmPassword) setConfirmPasswordError(true);
    if (
      !passwordError &&
      !confirmPasswordError &&
      inputUsername &&
      inputEmail &&
      emailCommunication
    ) {
      // Handle form submission here
      setIsSubmitting(true);
      const token = localStorage.getItem("token");
      let orgId = '',admin_Name='';
      if (token) {
        const code = jwtDecode(token);
        if (code.extension_Organization != undefined) {
          orgId = code.extension_Organization; // This will now work since orgId is declared with let
          admin_Name=code.name; 
        }
      }
      const postData = {
        userName: inputEmail,
        email:inputEmail,
        displayName: inputUsername,
        role: access,
        password: generatedPassword,
        organization : orgId,
        communicationEmail:emailCommunication,
        orgName:orgDetails.orgName,
        adminName:admin_Name,
      };
      setAddUserFlag(true);
      try {
        dispatch(addUserDataAPI(postData));
      } catch (error) {
        setIsSubmitting(false);
      }
    }
  };

  return (
  <div>
    {loading ? (
      <Loader />
    ) : (
      <>
        {allUserData.length > 0 ? (
          <>
            <ListView
              data={allUserData.slice(
                currentPage * rowsPerPage,
                (currentPage + 1) * rowsPerPage
              )}
              showToaster={showToaster}
              setDeleteStatusFlag={setDeleteUserFlag}
            />
            <CardPaginationTable
              totalItems={allUserData.length}
              page={currentPage}
              rowsPerPage={rowsPerPage}
              handleChangePage={handleChangePage}
            />
          </>
        ) : (
          <div className="emptyContainer">
            <img src="/images/empty-state.svg" alt="Empty State" />
            <p className="emptyMessage">
              <span className="titleMessage">No data available</span>
            </p>
          </div>
        )}
      </>
    )}

    <Modal
      open={openUserAdd}
      onClose={handleCloseUserAdd}
      size="tiny"
      className="add-document-model"
    >
      <Modal.Content data-cy="error-message-cy">
        <Header as="h3">Add new user</Header>
        <label>Username</label>
        <br />
        <Input
          type="text"
          name="username"
          value={inputUsername}
          onChange={handleChange}
          placeholder="Add name"
          className="add-datset-input"
          error={usernameError}
          data-cy="user-username-cy"
        />
        {usernameError && (
          <span style={{ color: "red" }}>Username is required</span>
        )}
        <br />
        <br />
        <label>Login ID</label>
        <br />
        <Input
          type="email"
          name="email"
          value={inputEmail}
          placeholder={`*****@${process.env.REACT_APP_EMAIL_DOMAIN}`}
          className="add-datset-input"
          error={emailError}
          readOnly={true}
        />
        {emailError && (
          <span style={{ color: "red" }}>Email is required</span>
        )}
        <br />
        <br />
        <label>Communication Email</label>
        <br />
        <Input
          type="email"
          name="communicationEmail"
          value={emailCommunication}
          onChange={(e) => setEmailCommunication(e.target.value)}
          placeholder="Enter communication email"
          className="add-datset-input"
          error={emailError} 
          data-cy="user-communicationEmail-cy"
        />
        {emailError && (
          <span style={{ color: "red" }}>Valid Communication Email is required</span>
        )}
        <br />
        <br />
        <input
        type="hidden"
        id="generatedPassword"
        value={generatedPassword}
        readOnly
        data-cy="user-password-cy"
      />
        <label>Access</label>
        <Dropdown
          placeholder="Select "
          fluid
          selection
          name="access"
          options={[
            { key: "1", text: "Admin", value: "Admin" },
            { key: "2", text: "DatasetAdmin", value: "DatasetAdmin" },
            { key: "3", text: "User", value: "User" },
            { key: "4", text: "QuickChatUser", value: "QuickChatUser" },
            { key: "5", text: "HumanAgent", value: "HumanAgent" },
            
          ]}
          onChange={handleChange}
          data-cy="user-dropdown-cy"
        />
      </Modal.Content>
      <Modal.Actions>
        <button
          className="cancel-btn"
          onClick={handleCloseUserAdd}
          data-cy="user-cancel-submit-btn"
        >
          Cancel
        </button>
        <button
          disabled={
            usernameError ||
            emailError ||
            passwordError ||
            confirmPasswordError ||
            inputUsername == '' ||
            isSubmitting
          }
          className="add-btn"
          onClick={handleSubmit}
          data-cy="user-submit-btn"
        >
          Add
        </button>
      </Modal.Actions>
    </Modal>
  </div>
);

};

export default UserList;
